import { render, staticRenderFns } from "./AppShortStats.vue?vue&type=template&id=1f1716a6&scoped=true&"
import script from "./AppShortStats.vue?vue&type=script&lang=js&"
export * from "./AppShortStats.vue?vue&type=script&lang=js&"
import style0 from "./AppShortStats.vue?vue&type=style&index=0&id=1f1716a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1716a6",
  null
  
)

export default component.exports